// TODO Need to load CLDR content

I18NService.create = function (locale) {
    var i18nService = new I18NService();
    var locales = navigator.language.split("-");
    //var locales = ["de"];

    // TODO Globalize API will be smarter ...

    i18nService.locale = locales[0];

    return i18nService;
}

/**
 * Globalize API
 * @constructor
 */
function I18NService() {
    I18NService.prototype.formatMessage = function (path) {
        var messages = this.i18nMessages;

        return eval("messages." + this.locale + "." + path.replace("/", "."));
    };

    this.i18nMessages = {
        en: {
            global: {
                yesLabel: "Yes",
                noLabel: "No",
                okLabel: "OK",
                applyLabel: "Apply",
                updateLabel: "Update",
                changeLabel: "Change",
                closeLabel: "Close",
                cancelLabel: "Cancel"
            },
            messageDialog: {title: "Message"},
            confirmationDialog: {title: "Confirmation"},
            sideMenu: {
                logoutLink: "Logout",
                homeLink: "Home",
                configurationLink: "Configuration",
                userManagementLink: "User Management",
                settingsLink: "Settings",
                notificationsLink: "Notification"
            },
            settingsPage: {
                title: "Settings",
                statusHeading: "Connection Status",
                serverModeLabel: "Server Mode",
                localGatewayComputerLabel: "Local Gateway",
                useLocalGatewayComputerLabel: "Use Local Gateway if Available",
                scanForLocalGatewayComputerLabel: "Scan for local Gateway",
                hostLabel: "Host",
                portLabel: "Port",
                connectedToGatewayBoxText: "Currently connected to local Gateway.",
                connectedToThingItText: "Currently connected to thing-it.com.",
                cloudServerHeader: "Cloud Server",
                useDefaultCloudServerLabel: "Use thing-it.com",
                cloudPortalServerLabel: "Portal Server",
                cloudProxyServerLabel: "Proxy Server",
                firmwareHeader: "Firmware",
                localeHeader: "Locale",
                localeLabel: "English",
                serverSettingsHeader: "Server Settings",
                displayHeader: "Display",
                showGatewaysLabel: "Show Gateways",
                showTasksLabel: "Show Tasks",
                showWikiLabel: "Show Wiki",
                showCommunicationLabel: "Show Communication",
                pairGatewayLabel: "Pair Gateway",
                repairGatewayLabel: "Re-Pair Gateway",
                newMeshLabel: "New Mesh",
                existingMeshLabel: "Existing Mesh"
            },
            gatewayConfigurationPage: {
                title: "Gateway Configuration",
                devicesHeader: "Devices",
                groupsHeader: "Groups",
                servicesHeader: "Services",
                eventProcessorsHeader: "Events",
                storyboardsHeader: "Storyboards",
                jobsHeader: "Jobs"
            },
            notificationsPage: {
                title: "Notifications",
                errorLabel: "Error",
                infoLabel: "Info",
                debugLabel: "Debug"
            }
        },
        de: {
            global: {
                yesLabel: "Ja",
                noLabel: "Nein",
                okLabel: "OK",
                applyLabel: "Anwenden",
                updateLabel: "Aktualisieren",
                changeLabel: "Ändern",
                closeLabel: "Schliessen",
                cancelLabel: "Abbrechen"
            },
            messageDialog: {title: "Nachricht"},
            confirmationDialog: {title: "Bestätigung"},
            sideMenu: {
                logoutLink: "Ausloggen",
                homeLink: "Startseite",
                configurationLink: "Konfiguration",
                userManagementLink: "Benutzerverwaltung",
                settingsLink: "Einstellungen",
                notificationsLink: "Benachrichtigungen"
            },
            settingsPage: {
                title: "Einstellungen",
                statusHeading: "Verbindungsstatus",
                serverModeLabel: "Server-Modus",
                localGatewayComputerLabel: "Lokales Gateway",
                useLocalGatewayComputerLabel: "Wenn möglich lokales Gateway verwenden",
                scanForLocalGatewayComputerLabel: "Nach Gateway suchen",
                hostLabel: "Host",
                portLabel: "Port",
                connectedToGatewayBoxText: "Aktuell mit dem lokales Gateway verbunden.",
                connectedToThingItText: "Aktuell mit thing-it.com verbunden.",
                cloudServerHeader: "Cloud Server",
                useDefaultCloudServerLabel: "thing-it.com verwenden",
                cloudPortalServerLabel: "Portal Server",
                cloudProxyServerLabel: "Proxy Server",
                firmwareHeader: "Firmware",
                localeHeader: "Ländereinstellung",
                localeLabel: "Deutsch",
                serverSettingsHeader: "Server-Einstellungen",
                displayHeader: "Anzeige",
                showGatewaysLabel: "Gateway anzeigen",
                showTasksLabel: "Aufgaben anzeigen",
                showWikiLabel: "Wiki anzeigen",
                showCommunicationLabel: "Kommunikation anzeigen",
                pairGatewayLabel: "Gateway paaren",
                repairGatewayLabel: "Neu paaren",
                newMeshLabel: "Neues Mesh",
                existingMeshLabel: "Existierendes Mesh"
            },
            gatewayConfigurationPage: {
                title: "Gateway-Konfiguration",
                devicesHeader: "Geräte",
                groupsHeader: "Gruppen",
                servicesHeader: "Dienste",
                eventProcessorsHeader: "Ereignisse",
                storyboardsHeader: "Abläufe",
                jobsHeader: "Kalendareinträge"
            },
            notificationsPage: {
                title: "Benachrichtigungen",
                errorLabel: "Fehler",
                infoLabel: "Info",
                debugLabel: "Analyse"
            }
        }
    };
}

/**
 *
 */
//Globalize.loadMessages();
